import { render } from "./DetalleProspectoPage.vue?vue&type=template&id=1d449d08"
import script from "./DetalleProspectoPage.vue?vue&type=script&lang=js"
export * from "./DetalleProspectoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__